module.exports = __webpack_public_path__ + "img/action_modifica.a4418af6.svg";